import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_AP,
  headers: {
    "Content-type": "application/json",
    //"access-token": JSON.parse(localStorage.getItem("jwt")),
  },
});
